import { render, staticRenderFns } from "./BaseCallToAction.vue?vue&type=template&id=3ce4a705&"
import script from "./BaseCallToAction.vue?vue&type=script&lang=ts&"
export * from "./BaseCallToAction.vue?vue&type=script&lang=ts&"
import style0 from "./BaseCallToAction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports